import React from 'react';

export interface AnalyticsMiniCardProps {
  id: string;
  title: string;
  value: number;
  infoTooltip?: string;
  clickable?: boolean;
  onClick?: () => void;
}

export const AnalyticsMiniCard: React.FC<AnalyticsMiniCardProps> = ({
  title,
  value,
  infoTooltip,
  clickable,
  onClick,
}) => {
  return (
    <div
      className={`bg-white rounded-lg border border-gray-200 min-h-[80px] min-w-[80px] p-3 flex flex-col ${
        clickable ? 'cursor-pointer hover:shadow-md hover:border-blue-300 transition-shadow' : ''
      }`}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onClick={clickable ? onClick : undefined}
      onKeyDown={clickable ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick?.(); } } : undefined}
    >
      {/* Header with title and info icon */}
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-gray-600 text-xs font-medium leading-tight truncate" title={title}>
          {title}
        </h3>
        <svg
          className="w-3 h-3 text-gray-400 cursor-pointer flex-shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          {infoTooltip && <title>{infoTooltip}</title>}
          <circle cx="12" cy="12" r="10" strokeWidth="2" />
          <path d="M12 16v-4M12 8h.01" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </div>

      {/* Main value - larger and bold */}
      <div className="flex-grow flex items-center">
        <p className="text-2xl font-bold text-gray-900">
          {value.toLocaleString()}
        </p>
      </div>
    </div>
  );
};
